import React from 'react';
import SMConst from 'lib/SMConst';

class SMReservationTabView extends React.Component {
  
  componentDidMount() {
    this.state = {
      isReadMessage: false
    };
  }
  
  componentWillReceiveProps(nextProps) {
    if (this.props.reservation !== nextProps.reservation){
    }
  }
  
  showReservationView(e) {
    e.preventDefault();
    if(this.props.delegate && typeof this.props.delegate.showReservationView === 'function'){
      this.props.delegate.showReservationView();
    }
  }
  
  showMessageView(e) {
    e.preventDefault();
    if(this.props.delegate && typeof this.props.delegate.showMessageView === 'function'){
      this.props.delegate.showMessageView();
    }
    this.setState({
      isReadMessage: true
    });
  }
  
  render(){
    if (!this.props.reservation) return <div ref="tab" />;
    let badge = <i className="fa fa-circle dashboard-tab__badge" />;
    if (this.props.reservation.is_read_message || this.state.is_read_message) {
      badge = null;
    }
    
    if (this.props.isMessageView) {
      return(
        <div ref="tab" className="dashboard-tab">
          <ul className="dashboard-tab__list">
            <li className="dashboard-tab__detail"><a href="#" onClick={this.showReservationView.bind(this)} title=""><span className="dashboard-tab__inner">予約詳細</span></a></li>
            <li className="dashboard-tab__message is-current"><span className="dashboard-tab__inner">メッセージ{badge}</span></li>
          </ul>
        </div>
      );
    } else {
      let clickEvent, reference, className;
      if (this.props.reservation.mediator == SMConst.ReservationMediator.SpaceMarket) {
        clickEvent = this.showMessageView.bind(this);
        reference = "#";
        className = "dashboard-tab__inner";
      } else {
        badge = null;
        clickEvent = null;
        reference = null;
        className = "dashboard-tab__inner is-disabled";
      }
      return(
        <div ref="tab" className="dashboard-tab">
          <ul className="dashboard-tab__list">
            <li className="dashboard-tab__detail is-current"><span className="dashboard-tab__inner">予約詳細</span></li>
            <li className="dashboard-tab__message">
              <a href={reference} onClick={clickEvent} title=""><span className={className}>メッセージ{badge}</span></a></li>
          </ul>
        </div>
      );
    }
  }
}
export default SMReservationTabView;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationTabView.jsx